import { useState } from 'react'

import { IDate } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { DotSeparator } from '@avantstay/backoffice-core'

import { clipText } from '@new/domains/operations/utils/text'

import { GuestInboxSend, GuestInboxTimelineEvent } from '../../StayTimeline.types'
import { getEventWhen } from '../../StayTimeline.utils'
import { ChannelTag } from '../ChannelTag'
import { getRecipientLabel, getRecipientRole } from '../SendRecipient'
import { SendStatusPill } from '../SendStatusPill'
import { Pill } from '../Shared.styles'
import * as S from './AutoCard.styles'

interface AutoCardProps {
  event: GuestInboxTimelineEvent
  send?: GuestInboxSend
  checkIn?: IDate | null
  checkout?: IDate | null
}

const BODY_CLIP = 260

export const AutoCard = ({ event, send, checkIn, checkout }: AutoCardProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const body = String(event.body ?? '')
  const isClipped = body.length > BODY_CLIP
  const when = getEventWhen(event.at, checkIn, checkout)
  const recipient = send?.recipient
  const recipientLabel = recipient ? getRecipientLabel(recipient) : undefined

  return (
    <S.Root>
      <S.Card>
        <S.Head>
          <S.Title>Automated send</S.Title>
          <S.Chip>AUTO</S.Chip>
          <ChannelTag channel={event.channel} medium={event.medium} />
          <S.Spacer />
          {send ? <SendStatusPill send={send} /> : null}
        </S.Head>

        <S.Body>
          {isOpen ? body : clipText(body, BODY_CLIP)}
          {isClipped ? (
            <S.Toggle type="button" onClick={() => setIsOpen(current => !current)}>
              {isOpen ? 'Show less' : 'Show full message'}
            </S.Toggle>
          ) : null}
        </S.Body>

        {send ? (
          <S.Meta>
            <S.MetaText>Template: {send.template}</S.MetaText>

            {recipient && recipientLabel ? (
              <>
                <DotSeparator spacing={0} />
                <S.MetaText>To: {recipientLabel}</S.MetaText>
                <Pill>{getRecipientRole(recipient)}</Pill>
              </>
            ) : null}
          </S.Meta>
        ) : null}
      </S.Card>

      {when ? <S.When>{when}</S.When> : null}
    </S.Root>
  )
}
